module.exports = __webpack_public_path__ + "assets/3aa9f7dbb65f598c3037674d72a3df21.png";